import React from 'react'
import dayjs from 'dayjs'
import styled from 'styled-components'
import { IPISPaymentStatus } from '@query'

interface Props {
  statuses: IPISPaymentStatus[]
  getStatusLabel: (status: IPISPaymentStatus) => string
  getStatusDescription: (status: IPISPaymentStatus) => string | null
}

export const PISStatusTimeline: React.FC<Props> = ({
  statuses,
  getStatusLabel,
  getStatusDescription
}) => {
  return (
    <Timeline>
      {statuses.map(status => {
        const description = getStatusDescription(status)
        return (
          <TimelineItem key={status.id}>
            <TimelineHeader>
              <span>{getStatusLabel(status)}</span>
              <TimelineTimestamp>{dayjs(status.created_at).format('L LT')}</TimelineTimestamp>
            </TimelineHeader>
            {description && <TimelineDescription>{description}</TimelineDescription>}
          </TimelineItem>
        )
      })}
    </Timeline>
  )
}

const Timeline = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.sm}rem;
  min-width: 220px;
`

const TimelineItem = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: ${({ theme }) => theme.spacing.md}rem;
  position: relative;

  &:before {
    content: '';
    position: absolute;
    left: 0;
    top: 0.4rem;
    width: 0.4rem;
    height: 0.4rem;
    border-radius: 999px;
    background: currentColor;
    opacity: 0.7;
    z-index: 1;
  }

  &:not(:last-child):after {
    content: '';
    position: absolute;
    left: 0.16rem;
    top: 1.15rem;
    bottom: 0;
    height: calc(100% - 0.4rem);
    width: 1px;
    background: rgba(255, 255, 255, 0.2);
  }
`

const TimelineHeader = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.sm}rem;
  align-items: baseline;
  justify-content: space-between;
  flex-wrap: wrap;
`

const TimelineTimestamp = styled.span`
  opacity: 0.7;
  font-size: ${({ theme }) => theme.fontSize.xs}rem;
`

const TimelineDescription = styled.span`
  opacity: 0.8;
  font-size: ${({ theme }) => theme.fontSize.xs}rem;
`
